import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "theme"
const DARK = "dark"
const LIGHT = "light"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.render(this.currentTheme)
  }

  toggle() {
    const next = this.currentTheme === DARK ? LIGHT : DARK
    localStorage.setItem(STORAGE_KEY, next)
    this.apply(next)
    this.render(next)
  }

  get currentTheme() {
    return document.documentElement.dataset.theme || DARK
  }

  apply(theme) {
    document.documentElement.dataset.theme = theme
  }

  render(theme) {
    if (!this.hasIconTarget) return
    this.iconTargets.forEach(el => {
      el.hidden = el.dataset.themeIcon !== theme
    })
  }
}
